import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import TopPlayerDto from "../../dto/TopPlayerDto";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  topPlayers: Array<TopPlayerDto>;
} = {
  loading: true,
  loadingData: true,
  topPlayers: undefined!,
};

export const topPlayersReducer = createSlice({
  name: "topPlayers",
  initialState,
  reducers: {
    loadTopPlayers(
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: PayloadAction<{
        tableSizeFilterValue?: number; //id фильтра
        limitFilterValue?: number; //id фильтра
        dateFilterValue?: number; //id фильтра
        customDateFilterValue?: { fromDate: string; toDate: string };
      }>
    ) {
      state.loadingData = true;
    },
    setLoadedTopPlayers(state, action: PayloadAction<Array<TopPlayerDto>>) {
      state.loading = false;
      state.loadingData = false;
      state.topPlayers = action.payload;
    },
  },
});
